import { createSelector } from 'reselect';

export const selectEmailSuccessful = createSelector(
  (state) => state.getIn(['contactUs', 'emailSuccessful']),
  (emailSuccessful) => emailSuccessful,
);

export const selectContactUsRecipientsLoading = createSelector(
  (state) => state.getIn(['contactUs', 'loading']),
  (loading) => loading,
);

export const selectContactUsRecipients = createSelector(
  (state) => state.getIn(['contactUs', 'recipients']),
  (recipients) => recipients.toJS(),
);

export const selectAdminContactUsRecipientsLoading = createSelector(
  (state) => state.getIn(['contactUs', 'adminLoading']),
  (loading) => loading,
);

export const selectAdminContactUsRecipients = createSelector(
  (state) => state.getIn(['contactUs', 'adminRecipients']),
  (recipients) => recipients.toJS(),
);
